class Accordion extends HTMLElement {
  constructor() {
    super();

    this.accordionTriggers = this.querySelectorAll(".accordion-header");
    this.autoCollapse = this.getAttribute("autoCollapse") !== "false";

    this.init();
  }

  init() {
    this.accordionTriggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => this.expandAccordion(e));
    });
  }

  expandAccordion(event) {
    const target = event.target.closest('.accordion-header');
    const isPanelExpanded = target.getAttribute("aria-expanded");

    if (this.autoCollapse){
      this.collapseAccordion();
    } else {
      this.collapseAccordion(target);
    }

    if (isPanelExpanded === "false") {
      target.setAttribute("aria-expanded", true);
      this.adjustAccordionHeight(target);
    } else {
      target.setAttribute("aria-expanded", false);
    }
  }

  adjustAccordionHeight(target) {
    const content = target.nextSibling;
    const contentWrapper = content.querySelector('.content-wrapper');
    const height = contentWrapper.offsetHeight;

    content.style.height = `${height}px`;
  }

  collapseAccordion(el) {
    if (el){
      el.setAttribute("aria-expanded", false);
      el.nextSibling.style.height = `0`;
      return;
    }

    this.accordionTriggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", false);

      trigger.nextSibling.style.height = `0`;
    });
  }
}

customElements.define("accordion-container", Accordion);
